

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setHeaderName, setSubHeaderName } from '../../../../ReduxStore/Slices/headerSlice';
import { Backdrop, Box, Button, Grid, Typography } from '@mui/material';
import CustomInputLogin from '../../../../Components/CustomInputLogin/CustomInputLogin';
import { Formik, Form } from 'formik';
import CustomExcelUpload from '../../../../Components/CustomExcelUpload/CustomExcelUpload';
import { BackHandSharp, Upload } from '@mui/icons-material';
import { IoIosArrowRoundBack } from "react-icons/io";
import CustomTable from '../../../../Components/Table/CustomTable';
import actions from '../../../../ReduxStore/actions';
import CustomInputForm from '../../../../Components/CustomInputLogin/CustomInputForm';
import { toast, ToastContainer } from 'react-toastify';
import CustomDropdownMui from '../../../../Components/CustomDropDown/CustomDropdown';
import * as Yup from 'yup';
import { adminUrl } from '../../../../constants';
import InvalidRowsModal from '../../../../Components/InvalidRowsModal/InvalidRowsModal';
import FullPageLoader from '../../../../Components/FullPageLoader/FullPageLoader';

const validationSchema = Yup.object().shape({
    department: Yup.string()
        .trim()
        .when('file', {
            is: (file) => !file,
            then: (schema) => schema.required('Department name is required.'),
            otherwise: (schema) => schema.notRequired(),
        }),
    subdepartment: Yup.string()
        .trim()
        .when('file', {
            is: (file) => !file,
            then: (schema) => schema.required('Subdepartment name is required.'),
            otherwise: (schema) => schema.notRequired(),
        }),
    file: Yup.mixed().nullable(),
});

const SubDepartment = () => {
    const dispatch = useDispatch();
    const [showExcelUpload, setShowExcelUpload] = useState(false); // State to toggle
    const tableHeadData = ["S.No", "Department", "Sub Department", "Actions"];
    const tableData = [
        { subdepartmentId: "3", department: "ASSEMBLY SUPERVISOR", subdepartment: "HR" },
        { subdepartmentId: "4", department: "ASSEMBLY SUPERVISOR", subdepartment: "HR" },
        { subdepartmentId: "5", department: "ASSEMBLY SUPERVISOR", subdepartment: "HR" },
        { subdepartmentId: "6", department: "ASSEMBLY SUPERVISOR", subdepartment: "HR" },

    ]


    useEffect(() => {
        dispatch(setHeaderName("Master"));
        dispatch(setSubHeaderName("Sub Department"));
    }, [dispatch]);

    const [editData, setEditData] = useState()
    const { updateSubDepartment } = useSelector((state) => state?.updateSubDepartment);
    const { createSubDepartment } = useSelector((state) => state?.createSubDepartment);
    const { bulkUploadSubDepartments } = useSelector((state) => state?.bulkUploadSubDepartments);
    const { getAllSubDepartments } = useSelector((state) => state?.getAllSubDepartments);


    const { getAllDepartments } = useSelector((state) => state?.getAllDepartments);

    const departmentOptions = getAllDepartments?.data?.map((data) => (
        { value: data?.department_id, label: data?.department_name }
    ))
    const [invalidRowsModalopen, setInvalidRowsModalOpen] = useState(false);
    const [invalidRwModalResponseData, setInvalidRwModalResponseData] = useState([]);

    const handleInvalidRowsModalOpen = () => {
        setInvalidRowsModalOpen(true)
    }
    const handleInvalidRowsModalClose = () => {
        setInvalidRowsModalOpen(false)
    }

    useEffect(() => {
        const fetchData = async () => {

            const data1 = {
                data: {},
                method: "get",
                apiName: "getAllDepartments"
            };
            const responseData = dispatch(actions.GETALLDEPARTMENTS(data1));
            console.log(responseData, "responseData")


        }
        fetchData()

    }, [])



    const [loading, setLoading] = useState(false);


    const handleSubmit = async (values, { resetForm }) => {
        console.log(values, "valuesssssss")
        setLoading(true)


        if (values?.file === null) {
            const data1 = {
                data: {
                    sub_department_name: values?.subdepartment,
                    department_id: Number(values?.department)
                },
                method: editData?.sub_department_id ? "put" : "post",
                apiName: editData?.sub_department_id ? `updateSubDepartment/${editData?.sub_department_id}` : "createSubDepartment"
            };
            const responseData = await dispatch(editData?.sub_department_id ? actions.UPDATEUSUBDEPARTMENT(data1) : actions.CREATESUBDEPARTMENT(data1));
            console.log(responseData, "responseData")
            if (responseData?.payload?.message === "Sub-department fetched successfully.") {
                setLoading(false)
                toast.success("Sub-department fetched successfully.")
                resetForm()
            } else if (responseData?.payload?.message === "Sub-department updated.") {
                setLoading(false)
                toast.success("Sub-department upadated successfully.")
                setEditData()
            }
            else {
                setLoading(false)
                toast.error(responseData?.payload?.message)
            }
        } else {
            const formData = new FormData();
            formData.append("file", values?.file);
            console.log(formData, "formData")
            const data1 = {
                data: formData,
                method: "post",
                apiName: "bulkUploadSubDepartments/bulk"
            };
            const responseData = await dispatch(actions.BULKUPLOADSUBDEPARTMENTS(data1));
            console.log(responseData, "responseData")
            if (responseData?.payload?.message === "Bulk upload successful.") {
                // toast.success("Bulk upload successful.")
                setLoading(false)
                setInvalidRwModalResponseData(responseData?.payload?.data)
                handleInvalidRowsModalOpen(true)

                resetForm()
            } else {
                setLoading(false)
                toast.error(responseData?.payload?.message)
            }

        }



    }

    // const handleSamplDownload = () => {
    //     // const data1 = {
    //     //     data: {},
    //     //     method: "get",
    //     //     apiName: "downloadAllSubDepartments/excel"
    //     // };
    //     // const responseData = dispatch(actions.DOWNLOADALLSUBDEPARTMENTS(data1));
    //     window.open(`${adminUrl}downloadSubDepartmentsSampleExcelFile`);



    // }

    const authToken = localStorage.getItem("authToken")
    const handleSamplDownload = async () => {
        try {
            const response = await fetch(`${adminUrl}downloadSubDepartmentsSampleExcelFile`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${authToken}`, // Replace with actual token
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'Sub_Department_Sample.xlsx'; // Set desired filename
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);
        }
    };
    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")




    useEffect(() => {
        const fetchData = async () => {

            const data1 = {
                data: {},
                method: "get",
                apiName: "getAllSubDepartments"
            };
            const responseData = dispatch(actions.GETALLSUBDEPARTMENTS(data1));
            console.log(responseData, "responseData")


        }
        fetchData()

    }, [updateSubDepartment, createSubDepartment, bulkUploadSubDepartments])

    useEffect(() => {

        const tempArr = [];

        getAllSubDepartments?.data?.map((data, index) => {
            return tempArr.push({
                // id: data?.internship_id,
                id: data?.sub_department_id,
                department_name: data?.department?.department_name,
                sub_department_name: data?.sub_department_name

            });
        });
        setRowTableData(tempArr);




    }, [getAllSubDepartments])




    const { getDepartmentById } = useSelector((state) => state?.getDepartmentById);


    const handleTableEdit = async (id) => {
        setShowExcelUpload(false)
        setLoading(false)
        window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top


        console.log(id, "idgretoriut")
        const data1 = {
            data: {},
            method: "get",
            apiName: `getSubDepartmentById/${id}`
        };
        const responseData = await dispatch(actions.GETSUBDEPARTMENTDBYID(data1));
        console.log(responseData, "getDepartmentById")
        if (responseData?.payload?.message === "Sub-department updated.") {
            setLoading(false)
            setEditData(responseData?.payload?.data)
        }


    }





    return (
        <Box>
            {loading && <FullPageLoader />}
            <Box
                sx={{
                    background: "white",
                    p: 3
                }}
            >
                <Box
                    sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                    <Typography variant='subtitle2' sx={{ color: "black", fontSize: "18px" }}>
                        {showExcelUpload ? 'Upload Excel' : 'Add Sub Department'}
                    </Typography>
                    <Typography
                        variant='body1'
                        onClick={() => {
                            setShowExcelUpload(!showExcelUpload)
                            setEditData()
                        }}
                        sx={{
                            textAlign: "end",
                            color: 'var(--main-color)',
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer"
                        }}
                    >
                        {showExcelUpload ? <IoIosArrowRoundBack style={{ mr: 1, fontSize: "25px" }} /> : <Upload sx={{ mr: 1 }} />}
                        {showExcelUpload ? 'Back to Form' : 'Upload Excel'}
                    </Typography>
                </Box>

                <Formik
                    enableReinitialize
                    initialValues={{
                        subdepartment: editData?.sub_department_name || '',
                        department: editData?.department_id || "",
                        file: null
                    }}
                    validationSchema={validationSchema}

                    onSubmit={handleSubmit}
                >
                    {({ errors, touched, handleChange, values, setFieldValue, resetForm }) => (
                        <Form>
                            <Grid container spacing={2} mt={2}>
                                <Grid item size={{ xs: 12, md: 6 }}>
                                    {showExcelUpload ? (
                                        <>
                                            <CustomExcelUpload
                                                values={values}
                                                setFieldValue={setFieldValue}
                                                resetForm={resetForm}
                                            />
                                            {/* <Typography variant='body1'
                                                sx={{
                                                    // borderBottom: "1px solid var(--main-color)",
                                                    cursor: "pointer",
                                                    color: "var(--main-color)"
                                                }}
                                            >Download & Sample Excel Format</Typography> */}
                                            {/* <a href="/sample.xlsx" download style={{ textDecoration: 'none' }}> */}
                                            <Typography
                                                onClick={handleSamplDownload}
                                                variant="body1"
                                                sx={{
                                                    cursor: "pointer",
                                                    color: "var(--main-color)"
                                                }}
                                            >
                                                Download & Sample Excel Format
                                            </Typography>
                                            {/* </a> */}

                                        </>
                                    ) : (
                                        <>
                                            <CustomDropdownMui
                                                name="department"
                                                label="Department"
                                                custPlaceholder="-- Select department --"
                                                options={departmentOptions}
                                            />
                                            <Box sx={{ mt: 2 }}>
                                                <CustomInputForm
                                                    name="subdepartment"
                                                    label="Sub Department"
                                                    custPlaceholder="Ex.ASSEMPLY"
                                                />
                                            </Box>
                                        </>
                                    )}
                                </Grid>

                                {/* {!showExcelUpload && ( */}
                                <Grid item size={{ xs: 12 }} sx={{ mt: 3 }}>
                                    <Button
                                        type="submit"
                                        variant='contained'
                                        sx={{
                                            background: "var(--main-color)",
                                            textTransform: "none"
                                        }}
                                    >
                                        {/* Submit */}
                                        {editData?.department_id ? "Update" : "Submit"}

                                    </Button>
                                </Grid>
                                {/* )} */}
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </Box>
            <Box
                sx={{
                    background: "white",
                    p: 3,
                    mt: 6
                }}
            >
                <Grid container spacing={2}>
                    <Grid item size={{ xs: 12 }} sx={{ width: "100px", flex: 1 }}>
                        <CustomTable
                            tableHeadData={tableHeadData}
                            tableData={rowTableData}
                            title="Sub Department List"
                            tableEdit={true}
                            tableActions={true}
                            tableSearch={true}
                            handleTableEdit={handleTableEdit}



                        />
                    </Grid>
                </Grid>
            </Box>
            <ToastContainer position="top-right" autoClose={1500} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="dark" />
            <InvalidRowsModal name="subDepartment" open={invalidRowsModalopen} onClose={handleInvalidRowsModalClose} data={invalidRwModalResponseData} />


        </Box >
    );
};

export default SubDepartment;
